import React from 'react';
import { CanvasSettings as SharedCanvasSettings } from '@thefinpedia/thefinpedia-shared/canvas';
import { rotateSvg } from '../../../../assets/images/canvas';

const CanvasSettings = (props) => (
  <SharedCanvasSettings rotateSvg={rotateSvg} {...props} />
);

export default CanvasSettings;
